export default {
  // Dashboard
  'menu.dashboard': '系统概览',
  'menu.dashboard.home': '系统概览',
  'menu.dashboard.device-activation': '设备激活数据',
  'menu.dashboard.ecs': '服务镜像版本',
  'menu.home': '首页',

  // Website Configuration
  'menu.website-config': '网站配置',
  'menu.website-config.countdown': '倒计时配置',
  'menu.website-config.home-banner': '首页横幅配置',
  'menu.website-config.community-showcase': '社区展示配置',
  'menu.website-config.github-deploy': '官网定时发布',

  // User Operations
  'menu.user-operations': '用户运营',
  'menu.user-operations.points': '积分管理',

  // Points Management
  'menu.points-management': '积分管理',
  'menu.points-management.overview': '积分概览',
  'menu.points-management.transactions': '积分交易记录',
  'menu.points-management.users': '用户积分管理',
  'menu.points-management.rules': '积分规则管理',

  // Product Management
  'menu.product-management': '产品管理',
  'menu.product-management.overview': '产品概览',
  'menu.product-management.sku': '产品列表',
  'menu.product-management.email-templates': '邮件模板',
  'menu.product-management.firmware': '固件管理',
  'menu.product-management.device': '设备管理',
  'menu.overview': '概览',
  'menu.sku': '产品列表',
  'menu.email-templates': '邮件模板',
  'menu.firmware': '固件管理',
  'menu.device': '设备管理',

  // Model Upload
  'menu.model-upload': '模型管理',
  'menu.model-upload.list': '全部模型',
  'menu.model-upload.create': '上传模型',
  'menu.model-upload.category': '分类管理',
  'menu.model-upload.license': '版权许可',
  'menu.model-upload.contest': '竞赛管理（正式网站）',
  'menu.model-upload.contest-preview': '竞赛管理（测试网站）',

  // Model Management
  'menu.model-management': '模型管理',
  'menu.model-management.official': '官方模型',

  // Permission Management
  'menu.permission': '权限管理',
  'menu.permission.roles': '角色管理',
  'menu.permission.permissions': '权限管理',
  'menu.permission.employees': '员工管理',
  'menu.roles': '角色管理',
  'menu.permissions': '权限管理',
  'menu.employees': '员工管理',

  // Sales Management
  'menu.sales-management': '销售管理',
  'menu.sales-management.ks-orders': 'KS订单管理',
  'menu.ks-orders': 'KS订单管理',

  // Monitoring
  'menu.monitoring': '监控中心',
  'menu.monitoring.domestic': '国内监控',
  'menu.monitoring.overseas': '海外监控',

  // User Operations
  'menu.points': '积分管理',

  // Account
  'menu.account': '账户',
  'menu.account.logout': '退出登录',

  // Common
  'menu.welcome': '欢迎',
  'menu.login': '登录',
  'menu.countdown': '倒计时配置',

  // Exception Pages
  'menu.exception': '异常页面',
  'menu.exception.403': '403 禁止访问',
  'menu.exception.404': '404 页面不存在',
  'menu.exception.500': '500 服务器错误',
};
